import type { ApolloLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { getHeaders, HeadersOptions } from '../utils/headers-provider';

export function makeBearerTokenLink(options?: HeadersOptions): ApolloLink {
    return setContext(async (_, ctx) => {
        if (ctx.noAuth) return ctx;

        return {
            ...ctx,
            headers: {
                ...(await getHeaders(options)),
                ...(ctx.headers ?? {}),
            },
        };
    });
}
